module.exports = __webpack_public_path__ + "static/img/guide@2x.0d28d322.png";